@if (breadcrumbs?.length > 0) {
<div class="col-13 p2">
    <a class="underline"
       [routerLink]="'/'">{{'Home' | translate}}</a>&nbsp;|

    @for (crumb of breadcrumbs; track $index) {
    @if (!$last) {
    <a class="underline"
       [routerLink]="crumb.url">{{crumb.label}}</a>&nbsp;|
    } @else {
    <span>{{crumb.label}}</span>
    }
    }
</div>
}